/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.3.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    alert_GetTypes(  cancelToken?: CancelToken | undefined): Promise<AlertTypeResponse[]> {
        let url_ = this.baseUrl + "/api/alerts/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetTypes(_response);
        });
    }

    protected processAlert_GetTypes(response: AxiosResponse): Promise<AlertTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlertTypeResponse[]>(<any>null);
    }

    alert_GetMe(  cancelToken?: CancelToken | undefined): Promise<AlertsResponse[]> {
        let url_ = this.baseUrl + "/api/alerts/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlert_GetMe(_response);
        });
    }

    protected processAlert_GetMe(response: AxiosResponse): Promise<AlertsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertsResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlertsResponse[]>(<any>null);
    }

    booking_Create(request: CreateBookingForGivenUserModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateBookingForGivenUserResponse> {
        let url_ = this.baseUrl + "/api/bookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_Create(_response);
        });
    }

    protected processBooking_Create(response: AxiosResponse): Promise<CreateBookingForGivenUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBookingForGivenUserResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBookingForGivenUserResponse>(<any>null);
    }

    booking_CreateForExternalUser(request: CreateBookingForExternalUserModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateBookingForGivenUserResponse> {
        let url_ = this.baseUrl + "/api/bookings/external";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_CreateForExternalUser(_response);
        });
    }

    protected processBooking_CreateForExternalUser(response: AxiosResponse): Promise<CreateBookingForGivenUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBookingForGivenUserResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBookingForGivenUserResponse>(<any>null);
    }

    booking_CreateMe(request: CreateBookingModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateBookingResponse> {
        let url_ = this.baseUrl + "/api/bookings/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_CreateMe(_response);
        });
    }

    protected processBooking_CreateMe(response: AxiosResponse): Promise<CreateBookingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBookingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBookingResponse>(<any>null);
    }

    booking_GetMeBookingInfoBy(start: Date, end: Date | null , cancelToken?: CancelToken | undefined): Promise<BookingResponse[]> {
        let url_ = this.baseUrl + "/api/bookings/me?";
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined and cannot be null.");
        else
            url_ += "start=" + encodeURIComponent(start ? "" + start.toJSON() : "") + "&";
        if (end === undefined)
            throw new Error("The parameter 'end' must be defined.");
        else if(end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_GetMeBookingInfoBy(_response);
        });
    }

    protected processBooking_GetMeBookingInfoBy(response: AxiosResponse): Promise<BookingResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingResponse[]>(<any>null);
    }

    booking_UpdateMe(id: string, request: UpdateBookingModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateBookingResponse> {
        let url_ = this.baseUrl + "/api/bookings/{id}/me";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_UpdateMe(_response);
        });
    }

    protected processBooking_UpdateMe(response: AxiosResponse): Promise<UpdateBookingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBookingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBookingResponse>(<any>null);
    }

    booking_GetMeBookingInfoById(id: string , cancelToken?: CancelToken | undefined): Promise<BookingResponse> {
        let url_ = this.baseUrl + "/api/bookings/{id}/me";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_GetMeBookingInfoById(_response);
        });
    }

    protected processBooking_GetMeBookingInfoById(response: AxiosResponse): Promise<BookingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingResponse>(<any>null);
    }

    booking_Cancel(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/bookings/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_Cancel(_response);
        });
    }

    protected processBooking_Cancel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    booking_GetBookingInfoBy(id: string, spaceTypeId: string | null, start: Date, end: Date , cancelToken?: CancelToken | undefined): Promise<DailyBookingsResponse[]> {
        let url_ = this.baseUrl + "/api/floors/{id}/bookings?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (spaceTypeId === undefined)
            throw new Error("The parameter 'spaceTypeId' must be defined.");
        else if(spaceTypeId !== null)
            url_ += "spaceTypeId=" + encodeURIComponent("" + spaceTypeId) + "&";
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined and cannot be null.");
        else
            url_ += "start=" + encodeURIComponent(start ? "" + start.toJSON() : "") + "&";
        if (end === undefined || end === null)
            throw new Error("The parameter 'end' must be defined and cannot be null.");
        else
            url_ += "end=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_GetBookingInfoBy(_response);
        });
    }

    protected processBooking_GetBookingInfoBy(response: AxiosResponse): Promise<DailyBookingsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyBookingsResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyBookingsResponse[]>(<any>null);
    }

    booking_Search(model: SearchBookingModel | undefined , cancelToken?: CancelToken | undefined): Promise<PaginatedItemsOfBookingSearchResponse> {
        let url_ = this.baseUrl + "/api/bookings/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking_Search(_response);
        });
    }

    protected processBooking_Search(response: AxiosResponse): Promise<PaginatedItemsOfBookingSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedItemsOfBookingSearchResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedItemsOfBookingSearchResponse>(<any>null);
    }

    building_Get(id: string , cancelToken?: CancelToken | undefined): Promise<BuildingResponse> {
        let url_ = this.baseUrl + "/api/buildings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Get(_response);
        });
    }

    protected processBuilding_Get(response: AxiosResponse): Promise<BuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuildingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingResponse>(<any>null);
    }

    building_Update(id: string, model: UpdateBuildingModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateBuildingResponse> {
        let url_ = this.baseUrl + "/api/buildings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Update(_response);
        });
    }

    protected processBuilding_Update(response: AxiosResponse): Promise<UpdateBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBuildingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBuildingResponse>(<any>null);
    }

    building_Delete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Delete(_response);
        });
    }

    protected processBuilding_Delete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_GetAll(getArchived: boolean | undefined, getUnpublished: boolean | undefined, getClosed: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<BuildingResponse[]> {
        let url_ = this.baseUrl + "/api/buildings?";
        if (getArchived === null)
            throw new Error("The parameter 'getArchived' cannot be null.");
        else if (getArchived !== undefined)
            url_ += "getArchived=" + encodeURIComponent("" + getArchived) + "&";
        if (getUnpublished === null)
            throw new Error("The parameter 'getUnpublished' cannot be null.");
        else if (getUnpublished !== undefined)
            url_ += "getUnpublished=" + encodeURIComponent("" + getUnpublished) + "&";
        if (getClosed === null)
            throw new Error("The parameter 'getClosed' cannot be null.");
        else if (getClosed !== undefined)
            url_ += "getClosed=" + encodeURIComponent("" + getClosed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_GetAll(_response);
        });
    }

    protected processBuilding_GetAll(response: AxiosResponse): Promise<BuildingResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingResponse[]>(<any>null);
    }

    building_Create(model: CreateBuildingModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateBuildingResponse> {
        let url_ = this.baseUrl + "/api/buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Create(_response);
        });
    }

    protected processBuilding_Create(response: AxiosResponse): Promise<CreateBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBuildingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBuildingResponse>(<any>null);
    }

    building_UploadImage(id: string, imageFile: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/uploadimage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_UploadImage(_response);
        });
    }

    protected processBuilding_UploadImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Publish(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Publish(_response);
        });
    }

    protected processBuilding_Publish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Unpublish(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/unpublish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Unpublish(_response);
        });
    }

    protected processBuilding_Unpublish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Open(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/open";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Open(_response);
        });
    }

    protected processBuilding_Open(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Close(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Close(_response);
        });
    }

    protected processBuilding_Close(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Archive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Archive(_response);
        });
    }

    protected processBuilding_Archive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    building_Unarchive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/buildings/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuilding_Unarchive(_response);
        });
    }

    protected processBuilding_Unarchive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    termCondition_Create(termConditionFile: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<CreateTermConditionResponse> {
        let url_ = this.baseUrl + "/api/termcondition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (termConditionFile === null || termConditionFile === undefined)
            throw new Error("The parameter 'termConditionFile' cannot be null.");
        else
            content_.append("termConditionFile", termConditionFile.data, termConditionFile.fileName ? termConditionFile.fileName : "termConditionFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermCondition_Create(_response);
        });
    }

    protected processTermCondition_Create(response: AxiosResponse): Promise<CreateTermConditionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTermConditionResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTermConditionResponse>(<any>null);
    }

    termCondition_Get(organizationId: number | null , cancelToken?: CancelToken | undefined): Promise<GetTermConditionResponse> {
        let url_ = this.baseUrl + "/api/termcondition?";
        if (organizationId === undefined)
            throw new Error("The parameter 'organizationId' must be defined.");
        else if(organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermCondition_Get(_response);
        });
    }

    protected processTermCondition_Get(response: AxiosResponse): Promise<GetTermConditionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTermConditionResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTermConditionResponse>(<any>null);
    }

    termCondition_Accept(  cancelToken?: CancelToken | undefined): Promise<AcceptedTermConditionResponse> {
        let url_ = this.baseUrl + "/api/termcondition/accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTermCondition_Accept(_response);
        });
    }

    protected processTermCondition_Accept(response: AxiosResponse): Promise<AcceptedTermConditionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptedTermConditionResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedTermConditionResponse>(<any>null);
    }

    document_Get(  cancelToken?: CancelToken | undefined): Promise<DocumentResponse[]> {
        let url_ = this.baseUrl + "/api/documents/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_Get(_response);
        });
    }

    protected processDocument_Get(response: AxiosResponse): Promise<DocumentResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse[]>(<any>null);
    }

    floor_GetAll(id: string, getArchived: boolean | undefined, getUnpublished: boolean | undefined, getClosed: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<FloorResponse[]> {
        let url_ = this.baseUrl + "/api/buildings/{id}/floors?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (getArchived === null)
            throw new Error("The parameter 'getArchived' cannot be null.");
        else if (getArchived !== undefined)
            url_ += "getArchived=" + encodeURIComponent("" + getArchived) + "&";
        if (getUnpublished === null)
            throw new Error("The parameter 'getUnpublished' cannot be null.");
        else if (getUnpublished !== undefined)
            url_ += "getUnpublished=" + encodeURIComponent("" + getUnpublished) + "&";
        if (getClosed === null)
            throw new Error("The parameter 'getClosed' cannot be null.");
        else if (getClosed !== undefined)
            url_ += "getClosed=" + encodeURIComponent("" + getClosed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_GetAll(_response);
        });
    }

    protected processFloor_GetAll(response: AxiosResponse): Promise<FloorResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FloorResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FloorResponse[]>(<any>null);
    }

    floor_Get(id: string , cancelToken?: CancelToken | undefined): Promise<FloorDetailResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Get(_response);
        });
    }

    protected processFloor_Get(response: AxiosResponse): Promise<FloorDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FloorDetailResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FloorDetailResponse>(<any>null);
    }

    floor_Update(id: string, model: UpdateFloorModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateFloorResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Update(_response);
        });
    }

    protected processFloor_Update(response: AxiosResponse): Promise<UpdateFloorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateFloorResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateFloorResponse>(<any>null);
    }

    floor_Delete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Delete(_response);
        });
    }

    protected processFloor_Delete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_GetFloorPlanModel(id: string , cancelToken?: CancelToken | undefined): Promise<FloorPlanResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}/model";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_GetFloorPlanModel(_response);
        });
    }

    protected processFloor_GetFloorPlanModel(response: AxiosResponse): Promise<FloorPlanResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FloorPlanResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FloorPlanResponse>(<any>null);
    }

    floor_SetFloorPlanModel(id: string, planModelFile: FileParameter | undefined, imageModelFile: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<UploadFloorPlanResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}/model";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (planModelFile === null || planModelFile === undefined)
            throw new Error("The parameter 'planModelFile' cannot be null.");
        else
            content_.append("planModelFile", planModelFile.data, planModelFile.fileName ? planModelFile.fileName : "planModelFile");
        if (imageModelFile !== null && imageModelFile !== undefined)
            content_.append("imageModelFile", imageModelFile.data, imageModelFile.fileName ? imageModelFile.fileName : "imageModelFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_SetFloorPlanModel(_response);
        });
    }

    protected processFloor_SetFloorPlanModel(response: AxiosResponse): Promise<UploadFloorPlanResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFloorPlanResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFloorPlanResponse>(<any>null);
    }

    floor_Create(model: CreateFloorModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateFloorResponse> {
        let url_ = this.baseUrl + "/api/floors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Create(_response);
        });
    }

    protected processFloor_Create(response: AxiosResponse): Promise<CreateFloorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateFloorResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateFloorResponse>(<any>null);
    }

    floor_SetFloorPlanMetadata(id: string, metadata: FloorplanMetadata | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadata);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_SetFloorPlanMetadata(_response);
        });
    }

    protected processFloor_SetFloorPlanMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_GetFloorPlanMetadata(id: string , cancelToken?: CancelToken | undefined): Promise<GetFloorplanMetadataResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_GetFloorPlanMetadata(_response);
        });
    }

    protected processFloor_GetFloorPlanMetadata(response: AxiosResponse): Promise<GetFloorplanMetadataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFloorplanMetadataResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFloorplanMetadataResponse>(<any>null);
    }

    floor_PublishDraft(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/publishdraft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_PublishDraft(_response);
        });
    }

    protected processFloor_PublishDraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_DropDraft(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/dropdraft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_DropDraft(_response);
        });
    }

    protected processFloor_DropDraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_Publish(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Publish(_response);
        });
    }

    protected processFloor_Publish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_UnPublish(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/unpublish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_UnPublish(_response);
        });
    }

    protected processFloor_UnPublish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_Open(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/open";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Open(_response);
        });
    }

    protected processFloor_Open(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_Archive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Archive(_response);
        });
    }

    protected processFloor_Archive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_UnArchive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_UnArchive(_response);
        });
    }

    protected processFloor_UnArchive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    floor_Close(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/floors/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor_Close(_response);
        });
    }

    protected processFloor_Close(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    incident_GetTypes(  cancelToken?: CancelToken | undefined): Promise<IncidentTypeResponse[]> {
        let url_ = this.baseUrl + "/api/incidents/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_GetTypes(_response);
        });
    }

    protected processIncident_GetTypes(response: AxiosResponse): Promise<IncidentTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidentTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentTypeResponse[]>(<any>null);
    }

    incident_GetProducts(incidentTypeId: string , cancelToken?: CancelToken | undefined): Promise<IncidentProductResponse[]> {
        let url_ = this.baseUrl + "/api/incidents/products?";
        if (incidentTypeId === undefined || incidentTypeId === null)
            throw new Error("The parameter 'incidentTypeId' must be defined and cannot be null.");
        else
            url_ += "incidentTypeId=" + encodeURIComponent("" + incidentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_GetProducts(_response);
        });
    }

    protected processIncident_GetProducts(response: AxiosResponse): Promise<IncidentProductResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidentProductResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentProductResponse[]>(<any>null);
    }

    incident_GetIncidentsBy(incidentTypeId: string , cancelToken?: CancelToken | undefined): Promise<IncidentReponse[]> {
        let url_ = this.baseUrl + "/api/incidents?";
        if (incidentTypeId === undefined || incidentTypeId === null)
            throw new Error("The parameter 'incidentTypeId' must be defined and cannot be null.");
        else
            url_ += "incidentTypeId=" + encodeURIComponent("" + incidentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_GetIncidentsBy(_response);
        });
    }

    protected processIncident_GetIncidentsBy(response: AxiosResponse): Promise<IncidentReponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidentReponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentReponse[]>(<any>null);
    }

    incident_CreateIncident(model: CreateIncidentReportModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateMeIncidentResponse> {
        let url_ = this.baseUrl + "/api/incidents/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_CreateIncident(_response);
        });
    }

    protected processIncident_CreateIncident(response: AxiosResponse): Promise<CreateMeIncidentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateMeIncidentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateMeIncidentResponse>(<any>null);
    }

    incident_ResolveIncident(id: string , cancelToken?: CancelToken | undefined): Promise<ResolveIncidentResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/resolve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_ResolveIncident(_response);
        });
    }

    protected processIncident_ResolveIncident(response: AxiosResponse): Promise<ResolveIncidentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolveIncidentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolveIncidentResponse>(<any>null);
    }

    incident_UnResolveIncident(id: string , cancelToken?: CancelToken | undefined): Promise<ResolveIncidentResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/unresolve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_UnResolveIncident(_response);
        });
    }

    protected processIncident_UnResolveIncident(response: AxiosResponse): Promise<ResolveIncidentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolveIncidentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolveIncidentResponse>(<any>null);
    }

    incident_ResolveIncidentByProduct(id: string, productId: string , cancelToken?: CancelToken | undefined): Promise<ResolveIncidentResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/resolveproduct/{productId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_ResolveIncidentByProduct(_response);
        });
    }

    protected processIncident_ResolveIncidentByProduct(response: AxiosResponse): Promise<ResolveIncidentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolveIncidentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolveIncidentResponse>(<any>null);
    }

    incident_UnResolveIncidentByProduct(id: string, productId: string , cancelToken?: CancelToken | undefined): Promise<ResolveIncidentResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/unresolveproduct/{productId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_UnResolveIncidentByProduct(_response);
        });
    }

    protected processIncident_UnResolveIncidentByProduct(response: AxiosResponse): Promise<ResolveIncidentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolveIncidentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolveIncidentResponse>(<any>null);
    }

    incident_Search(model: SearchIncidentModel | undefined , cancelToken?: CancelToken | undefined): Promise<PaginatedItemsOfIncidentSearchReponse> {
        let url_ = this.baseUrl + "/api/incidents/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncident_Search(_response);
        });
    }

    protected processIncident_Search(response: AxiosResponse): Promise<PaginatedItemsOfIncidentSearchReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedItemsOfIncidentSearchReponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedItemsOfIncidentSearchReponse>(<any>null);
    }

    mobileDevice_RegisterMe(model: RegisterMobileDeviceModel | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/mobiledevices/registerMe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMobileDevice_RegisterMe(_response);
        });
    }

    protected processMobileDevice_RegisterMe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    privacyPolicy_Create(privacyFile: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<CreatePrivacyPolicyResponse> {
        let url_ = this.baseUrl + "/api/privacypolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (privacyFile === null || privacyFile === undefined)
            throw new Error("The parameter 'privacyFile' cannot be null.");
        else
            content_.append("privacyFile", privacyFile.data, privacyFile.fileName ? privacyFile.fileName : "privacyFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivacyPolicy_Create(_response);
        });
    }

    protected processPrivacyPolicy_Create(response: AxiosResponse): Promise<CreatePrivacyPolicyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreatePrivacyPolicyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePrivacyPolicyResponse>(<any>null);
    }

    privacyPolicy_Get(organizationId: number | null , cancelToken?: CancelToken | undefined): Promise<GetPrivacyPolicyResponse> {
        let url_ = this.baseUrl + "/api/privacypolicy?";
        if (organizationId === undefined)
            throw new Error("The parameter 'organizationId' must be defined.");
        else if(organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivacyPolicy_Get(_response);
        });
    }

    protected processPrivacyPolicy_Get(response: AxiosResponse): Promise<GetPrivacyPolicyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrivacyPolicyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrivacyPolicyResponse>(<any>null);
    }

    privacyPolicy_Accept(  cancelToken?: CancelToken | undefined): Promise<AcceptedPrivacyPolicyResponse> {
        let url_ = this.baseUrl + "/api/privacypolicy/accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivacyPolicy_Accept(_response);
        });
    }

    protected processPrivacyPolicy_Accept(response: AxiosResponse): Promise<AcceptedPrivacyPolicyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptedPrivacyPolicyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedPrivacyPolicyResponse>(<any>null);
    }

    profile_Get(  cancelToken?: CancelToken | undefined): Promise<GetUserProfileResponse> {
        let url_ = this.baseUrl + "/api/profiles/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_Get(_response);
        });
    }

    protected processProfile_Get(response: AxiosResponse): Promise<GetUserProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileResponse>(<any>null);
    }

    profile_Update(model: UpdateProfileModel | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserProfileResponse> {
        let url_ = this.baseUrl + "/api/profiles/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_Update(_response);
        });
    }

    protected processProfile_Update(response: AxiosResponse): Promise<GetUserProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileResponse>(<any>null);
    }

    profile_Update2(userImage: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserProfileResponse> {
        let url_ = this.baseUrl + "/api/profiles/me/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userImage === null || userImage === undefined)
            throw new Error("The parameter 'userImage' cannot be null.");
        else
            content_.append("userImage", userImage.data, userImage.fileName ? userImage.fileName : "userImage");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_Update2(_response);
        });
    }

    protected processProfile_Update2(response: AxiosResponse): Promise<GetUserProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileResponse>(<any>null);
    }

    profile_Search(name: string | null , cancelToken?: CancelToken | undefined): Promise<UserResponse[]> {
        let url_ = this.baseUrl + "/api/profiles/search?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if(name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_Search(_response);
        });
    }

    protected processProfile_Search(response: AxiosResponse): Promise<UserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse[]>(<any>null);
    }

    profile_SearchActives(name: string | null , cancelToken?: CancelToken | undefined): Promise<UserResponse[]> {
        let url_ = this.baseUrl + "/api/profiles/searchactives?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if(name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_SearchActives(_response);
        });
    }

    protected processProfile_SearchActives(response: AxiosResponse): Promise<UserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse[]>(<any>null);
    }

    profile_PatchActive(id: string, model: PatchIsActiveUserProfileModel | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/profiles/{id}/isactive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile_PatchActive(_response);
        });
    }

    protected processProfile_PatchActive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    report_Get(  cancelToken?: CancelToken | undefined): Promise<ReportResponse[]> {
        let url_ = this.baseUrl + "/api/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_Get(_response);
        });
    }

    protected processReport_Get(response: AxiosResponse): Promise<ReportResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportResponse[]>(<any>null);
    }

    report_GetReportParams(id: string , cancelToken?: CancelToken | undefined): Promise<GetReportParamsResponse> {
        let url_ = this.baseUrl + "/api/reports/{id}/params";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport_GetReportParams(_response);
        });
    }

    protected processReport_GetReportParams(response: AxiosResponse): Promise<GetReportParamsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportParamsResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportParamsResponse>(<any>null);
    }

    riskPerson_Search(model: SearchRiskPersonModel | undefined , cancelToken?: CancelToken | undefined): Promise<PaginatedItemsOfSearchRiskPersonResponse> {
        let url_ = this.baseUrl + "/api/riskpersons/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiskPerson_Search(_response);
        });
    }

    protected processRiskPerson_Search(response: AxiosResponse): Promise<PaginatedItemsOfSearchRiskPersonResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedItemsOfSearchRiskPersonResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedItemsOfSearchRiskPersonResponse>(<any>null);
    }

    sample_Get(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/samples/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSample_Get(_response);
        });
    }

    protected processSample_Get(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    sample_Update(id: string, model: UpdateSampleModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateSampleResponse> {
        let url_ = this.baseUrl + "/api/samples/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSample_Update(_response);
        });
    }

    protected processSample_Update(response: AxiosResponse): Promise<UpdateSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateSampleResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateSampleResponse>(<any>null);
    }

    sample_GetAll(  cancelToken?: CancelToken | undefined): Promise<CreateSampleResponse[]> {
        let url_ = this.baseUrl + "/api/samples";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSample_GetAll(_response);
        });
    }

    protected processSample_GetAll(response: AxiosResponse): Promise<CreateSampleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateSampleResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSampleResponse[]>(<any>null);
    }

    sample_Create(model: CreateSampleModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateSampleResponse> {
        let url_ = this.baseUrl + "/api/samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSample_Create(_response);
        });
    }

    protected processSample_Create(response: AxiosResponse): Promise<CreateSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateSampleResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSampleResponse>(<any>null);
    }

    shiftType_GetAll(id: string , cancelToken?: CancelToken | undefined): Promise<ShiftTypeResponse[]> {
        let url_ = this.baseUrl + "/api/buildings/{id}/shifttypes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShiftType_GetAll(_response);
        });
    }

    protected processShiftType_GetAll(response: AxiosResponse): Promise<ShiftTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftTypeResponse[]>(<any>null);
    }

    spaceType_GetAll(  cancelToken?: CancelToken | undefined): Promise<SpaceTypeResponse[]> {
        let url_ = this.baseUrl + "/api/spacetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpaceType_GetAll(_response);
        });
    }

    protected processSpaceType_GetAll(response: AxiosResponse): Promise<SpaceTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpaceTypeResponse[]>(<any>null);
    }

    survey_GetHealthSurveyDefinition(  cancelToken?: CancelToken | undefined): Promise<SurveyDefinitionResponse> {
        let url_ = this.baseUrl + "/api/surveys/health/definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_GetHealthSurveyDefinition(_response);
        });
    }

    protected processSurvey_GetHealthSurveyDefinition(response: AxiosResponse): Promise<SurveyDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyDefinitionResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDefinitionResponse>(<any>null);
    }

    survey_CreateHealthMe(model: CreateHealthSurveyModel[] | undefined , cancelToken?: CancelToken | undefined): Promise<CreateHealthSurveyResponse> {
        let url_ = this.baseUrl + "/api/surveys/health/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_CreateHealthMe(_response);
        });
    }

    protected processSurvey_CreateHealthMe(response: AxiosResponse): Promise<CreateHealthSurveyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateHealthSurveyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateHealthSurveyResponse>(<any>null);
    }

    survey_GetHealthMe(  cancelToken?: CancelToken | undefined): Promise<SurveyResponse> {
        let url_ = this.baseUrl + "/api/surveys/health/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_GetHealthMe(_response);
        });
    }

    protected processSurvey_GetHealthMe(response: AxiosResponse): Promise<SurveyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponse>(<any>null);
    }

    survey_CreateFeelingMe(model: CreateFeelingSurveyModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateFeelingSurveyResponse> {
        let url_ = this.baseUrl + "/api/surveys/feeling/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_CreateFeelingMe(_response);
        });
    }

    protected processSurvey_CreateFeelingMe(response: AxiosResponse): Promise<CreateFeelingSurveyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateFeelingSurveyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateFeelingSurveyResponse>(<any>null);
    }

    survey_GetFeelingMe(date: Date , cancelToken?: CancelToken | undefined): Promise<SurveyFeelingResponse> {
        let url_ = this.baseUrl + "/api/surveys/feeling/me?";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_GetFeelingMe(_response);
        });
    }

    protected processSurvey_GetFeelingMe(response: AxiosResponse): Promise<SurveyFeelingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyFeelingResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyFeelingResponse>(<any>null);
    }

    survey_CreateCovid19Me(model: CreateCovid19SurveyModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateCovid19SurveyResponse> {
        let url_ = this.baseUrl + "/api/surveys/covid19/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_CreateCovid19Me(_response);
        });
    }

    protected processSurvey_CreateCovid19Me(response: AxiosResponse): Promise<CreateCovid19SurveyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateCovid19SurveyResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateCovid19SurveyResponse>(<any>null);
    }

    survey_GetCovid19Me(date: Date , cancelToken?: CancelToken | undefined): Promise<SurveyCovid19Response> {
        let url_ = this.baseUrl + "/api/surveys/covid19/me?";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_GetCovid19Me(_response);
        });
    }

    protected processSurvey_GetCovid19Me(response: AxiosResponse): Promise<SurveyCovid19Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyCovid19Response.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyCovid19Response>(<any>null);
    }

    survey_GetCovid19(model: SearchCovid19SurveyModel | undefined , cancelToken?: CancelToken | undefined): Promise<PaginatedItemsOfSurveyCovid19SearchResponse> {
        let url_ = this.baseUrl + "/api/surveys/covid19/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSurvey_GetCovid19(_response);
        });
    }

    protected processSurvey_GetCovid19(response: AxiosResponse): Promise<PaginatedItemsOfSurveyCovid19SearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedItemsOfSurveyCovid19SearchResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedItemsOfSurveyCovid19SearchResponse>(<any>null);
    }

    venue_Get(id: string , cancelToken?: CancelToken | undefined): Promise<VenueResponse> {
        let url_ = this.baseUrl + "/api/venues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Get(_response);
        });
    }

    protected processVenue_Get(response: AxiosResponse): Promise<VenueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VenueResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VenueResponse>(<any>null);
    }

    venue_Update(id: string, model: UpdateVenueModel | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateVenueResponse> {
        let url_ = this.baseUrl + "/api/venues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Update(_response);
        });
    }

    protected processVenue_Update(response: AxiosResponse): Promise<UpdateVenueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateVenueResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateVenueResponse>(<any>null);
    }

    venue_Delete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/venues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Delete(_response);
        });
    }

    protected processVenue_Delete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    venue_GetAll(getArchived: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllVenueResponse[]> {
        let url_ = this.baseUrl + "/api/venues?";
        if (getArchived === null)
            throw new Error("The parameter 'getArchived' cannot be null.");
        else if (getArchived !== undefined)
            url_ += "getArchived=" + encodeURIComponent("" + getArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_GetAll(_response);
        });
    }

    protected processVenue_GetAll(response: AxiosResponse): Promise<GetAllVenueResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllVenueResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllVenueResponse[]>(<any>null);
    }

    venue_Create(model: CreateVenueModel | undefined , cancelToken?: CancelToken | undefined): Promise<CreateVenueResponse> {
        let url_ = this.baseUrl + "/api/venues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Create(_response);
        });
    }

    protected processVenue_Create(response: AxiosResponse): Promise<CreateVenueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateVenueResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateVenueResponse>(<any>null);
    }

    venue_Archive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/venues/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Archive(_response);
        });
    }

    protected processVenue_Archive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    venue_Unarchive(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/venues/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_Unarchive(_response);
        });
    }

    protected processVenue_Unarchive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    venue_GetByVenue(id: string, getArchived: boolean | undefined, getUnpublished: boolean | undefined, getClosed: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<BuildingResponse[]> {
        let url_ = this.baseUrl + "/api/venues/{id}/buildings?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (getArchived === null)
            throw new Error("The parameter 'getArchived' cannot be null.");
        else if (getArchived !== undefined)
            url_ += "getArchived=" + encodeURIComponent("" + getArchived) + "&";
        if (getUnpublished === null)
            throw new Error("The parameter 'getUnpublished' cannot be null.");
        else if (getUnpublished !== undefined)
            url_ += "getUnpublished=" + encodeURIComponent("" + getUnpublished) + "&";
        if (getClosed === null)
            throw new Error("The parameter 'getClosed' cannot be null.");
        else if (getClosed !== undefined)
            url_ += "getClosed=" + encodeURIComponent("" + getClosed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVenue_GetByVenue(_response);
        });
    }

    protected processVenue_GetByVenue(response: AxiosResponse): Promise<BuildingResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingResponse[]>(<any>null);
    }

    spaces_GetSpaceWorkplacesByFloor(id: string , cancelToken?: CancelToken | undefined): Promise<SpaceWorkStationResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}/workstations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpaces_GetSpaceWorkplacesByFloor(_response);
        });
    }

    protected processSpaces_GetSpaceWorkplacesByFloor(response: AxiosResponse): Promise<SpaceWorkStationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpaceWorkStationResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpaceWorkStationResponse>(<any>null);
    }

    spaces_GetSpaceMeetingRoomsByFloor(id: string , cancelToken?: CancelToken | undefined): Promise<SpaceMeetingRoomResponse> {
        let url_ = this.baseUrl + "/api/floors/{id}/meetingrooms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpaces_GetSpaceMeetingRoomsByFloor(_response);
        });
    }

    protected processSpaces_GetSpaceMeetingRoomsByFloor(response: AxiosResponse): Promise<SpaceMeetingRoomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpaceMeetingRoomResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpaceMeetingRoomResponse>(<any>null);
    }

    spaces_Enable(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/spaces/{id}/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpaces_Enable(_response);
        });
    }

    protected processSpaces_Enable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    spaces_Disable(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/spaces/{id}/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpaces_Disable(_response);
        });
    }

    protected processSpaces_Disable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    workPlaceType_GetWorkplaceTypes(  cancelToken?: CancelToken | undefined): Promise<WorkPlaceTypeResponse[]> {
        let url_ = this.baseUrl + "/api/workplacetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWorkPlaceType_GetWorkplaceTypes(_response);
        });
    }

    protected processWorkPlaceType_GetWorkplaceTypes(response: AxiosResponse): Promise<WorkPlaceTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkPlaceTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkPlaceTypeResponse[]>(<any>null);
    }

    workStationType_GetWorkStationTypes(  cancelToken?: CancelToken | undefined): Promise<WorkStationTypeResponse[]> {
        let url_ = this.baseUrl + "/api/workstationtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWorkStationType_GetWorkStationTypes(_response);
        });
    }

    protected processWorkStationType_GetWorkStationTypes(response: AxiosResponse): Promise<WorkStationTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationTypeResponse.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkStationTypeResponse[]>(<any>null);
    }
}

export class AlertTypeResponse implements IAlertTypeResponse {
    id!: string;
    name!: string;
    code!: string;

    constructor(data?: IAlertTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AlertTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AlertTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IAlertTypeResponse {
    id: string;
    name: string;
    code: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    constructor(data?: IValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors: { [key: string]: string[]; };
}

export class AlertsResponse implements IAlertsResponse {
    id!: string;
    alertTypeId!: string;
    date!: Date;
    payLoad!: string;
    alert!: any;

    constructor(data?: IAlertsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alertTypeId = _data["alertTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.payLoad = _data["payLoad"];
            this.alert = _data["alert"];
        }
    }

    static fromJS(data: any): AlertsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alertTypeId"] = this.alertTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["payLoad"] = this.payLoad;
        data["alert"] = this.alert;
        return data; 
    }
}

export interface IAlertsResponse {
    id: string;
    alertTypeId: string;
    date: Date;
    payLoad: string;
    alert: any;
}

export class CreateBookingForGivenUserResponse implements ICreateBookingForGivenUserResponse {
    bookingId!: string;

    constructor(data?: ICreateBookingForGivenUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): CreateBookingForGivenUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingForGivenUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        return data; 
    }
}

export interface ICreateBookingForGivenUserResponse {
    bookingId: string;
}

export class CreateBookingForGivenUserModel implements ICreateBookingForGivenUserModel {
    userId!: string;
    shiftTypeId!: string;
    date!: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId!: string;

    constructor(data?: ICreateBookingForGivenUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.spaceId = _data["spaceId"];
        }
    }

    static fromJS(data: any): CreateBookingForGivenUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingForGivenUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["spaceId"] = this.spaceId;
        return data; 
    }
}

export interface ICreateBookingForGivenUserModel {
    userId: string;
    shiftTypeId: string;
    date: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId: string;
}

export class CreateBookingForExternalUserModel implements ICreateBookingForExternalUserModel {
    userEmail!: string;
    shiftTypeId!: string;
    date!: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId!: string;

    constructor(data?: ICreateBookingForExternalUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.spaceId = _data["spaceId"];
        }
    }

    static fromJS(data: any): CreateBookingForExternalUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingForExternalUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["spaceId"] = this.spaceId;
        return data; 
    }
}

export interface ICreateBookingForExternalUserModel {
    userEmail: string;
    shiftTypeId: string;
    date: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId: string;
}

export class CreateBookingResponse implements ICreateBookingResponse {
    bookingId!: string;

    constructor(data?: ICreateBookingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): CreateBookingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        return data; 
    }
}

export interface ICreateBookingResponse {
    bookingId: string;
}

export class CreateBookingModel implements ICreateBookingModel {
    shiftTypeId!: string;
    date!: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId!: string;
    externalAttendees?: ExternalBookingAttendee[] | undefined;
    internalAttendees?: InternalBookingAttendee[] | undefined;

    constructor(data?: ICreateBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.spaceId = _data["spaceId"];
            if (Array.isArray(_data["externalAttendees"])) {
                this.externalAttendees = [] as any;
                for (let item of _data["externalAttendees"])
                    this.externalAttendees!.push(ExternalBookingAttendee.fromJS(item));
            }
            if (Array.isArray(_data["internalAttendees"])) {
                this.internalAttendees = [] as any;
                for (let item of _data["internalAttendees"])
                    this.internalAttendees!.push(InternalBookingAttendee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["spaceId"] = this.spaceId;
        if (Array.isArray(this.externalAttendees)) {
            data["externalAttendees"] = [];
            for (let item of this.externalAttendees)
                data["externalAttendees"].push(item.toJSON());
        }
        if (Array.isArray(this.internalAttendees)) {
            data["internalAttendees"] = [];
            for (let item of this.internalAttendees)
                data["internalAttendees"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateBookingModel {
    shiftTypeId: string;
    date: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId: string;
    externalAttendees?: ExternalBookingAttendee[] | undefined;
    internalAttendees?: InternalBookingAttendee[] | undefined;
}

export class ExternalBookingAttendee implements IExternalBookingAttendee {
    name!: string;
    email!: string;

    constructor(data?: IExternalBookingAttendee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExternalBookingAttendee {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalBookingAttendee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        return data; 
    }
}

export interface IExternalBookingAttendee {
    name: string;
    email: string;
}

export class InternalBookingAttendee implements IInternalBookingAttendee {
    userId!: string;

    constructor(data?: IInternalBookingAttendee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): InternalBookingAttendee {
        data = typeof data === 'object' ? data : {};
        let result = new InternalBookingAttendee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IInternalBookingAttendee {
    userId: string;
}

export class UpdateBookingResponse implements IUpdateBookingResponse {
    bookingId!: string;
    spaceId!: string;
    shiftTypeId!: string;
    date!: Date;
    start?: string | undefined;
    end?: string | undefined;

    constructor(data?: IUpdateBookingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.spaceId = _data["spaceId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): UpdateBookingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["spaceId"] = this.spaceId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        return data; 
    }
}

export interface IUpdateBookingResponse {
    bookingId: string;
    spaceId: string;
    shiftTypeId: string;
    date: Date;
    start?: string | undefined;
    end?: string | undefined;
}

export class UpdateBookingModel implements IUpdateBookingModel {
    shiftTypeId!: string;
    date!: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId!: string;
    externalAttendees?: ExternalBookingAttendee[] | undefined;
    internalAttendees?: InternalBookingAttendee[] | undefined;

    constructor(data?: IUpdateBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.spaceId = _data["spaceId"];
            if (Array.isArray(_data["externalAttendees"])) {
                this.externalAttendees = [] as any;
                for (let item of _data["externalAttendees"])
                    this.externalAttendees!.push(ExternalBookingAttendee.fromJS(item));
            }
            if (Array.isArray(_data["internalAttendees"])) {
                this.internalAttendees = [] as any;
                for (let item of _data["internalAttendees"])
                    this.internalAttendees!.push(InternalBookingAttendee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["spaceId"] = this.spaceId;
        if (Array.isArray(this.externalAttendees)) {
            data["externalAttendees"] = [];
            for (let item of this.externalAttendees)
                data["externalAttendees"].push(item.toJSON());
        }
        if (Array.isArray(this.internalAttendees)) {
            data["internalAttendees"] = [];
            for (let item of this.internalAttendees)
                data["internalAttendees"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateBookingModel {
    shiftTypeId: string;
    date: Date;
    start?: string | undefined;
    end?: string | undefined;
    spaceId: string;
    externalAttendees?: ExternalBookingAttendee[] | undefined;
    internalAttendees?: InternalBookingAttendee[] | undefined;
}

export class DailyBookingsResponse implements IDailyBookingsResponse {
    date!: Date;
    venueId!: string;
    venueName!: string;
    buildingId!: string;
    buildingName!: string;
    floorId!: string;
    floorName!: string;
    spaceWorkStations!: BookingSpaceWorkStationResponse[];
    spaceMeetingRooms!: BookingSpaceMeetingRoomResponse[];
    users!: BookingUserResponse[];

    constructor(data?: IDailyBookingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.spaceWorkStations = [];
            this.spaceMeetingRooms = [];
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.floorId = _data["floorId"];
            this.floorName = _data["floorName"];
            if (Array.isArray(_data["spaceWorkStations"])) {
                this.spaceWorkStations = [] as any;
                for (let item of _data["spaceWorkStations"])
                    this.spaceWorkStations!.push(BookingSpaceWorkStationResponse.fromJS(item));
            }
            if (Array.isArray(_data["spaceMeetingRooms"])) {
                this.spaceMeetingRooms = [] as any;
                for (let item of _data["spaceMeetingRooms"])
                    this.spaceMeetingRooms!.push(BookingSpaceMeetingRoomResponse.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(BookingUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyBookingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyBookingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["floorId"] = this.floorId;
        data["floorName"] = this.floorName;
        if (Array.isArray(this.spaceWorkStations)) {
            data["spaceWorkStations"] = [];
            for (let item of this.spaceWorkStations)
                data["spaceWorkStations"].push(item.toJSON());
        }
        if (Array.isArray(this.spaceMeetingRooms)) {
            data["spaceMeetingRooms"] = [];
            for (let item of this.spaceMeetingRooms)
                data["spaceMeetingRooms"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDailyBookingsResponse {
    date: Date;
    venueId: string;
    venueName: string;
    buildingId: string;
    buildingName: string;
    floorId: string;
    floorName: string;
    spaceWorkStations: BookingSpaceWorkStationResponse[];
    spaceMeetingRooms: BookingSpaceMeetingRoomResponse[];
    users: BookingUserResponse[];
}

export class BookingSpaceResponse implements IBookingSpaceResponse {
    spaceId!: string;
    spaceTypeId!: string;
    isEnabled!: boolean;
    isLocked!: boolean;
    waveId!: string;
    label!: string;
    bookings!: SpaceBookingResponse[];

    constructor(data?: IBookingSpaceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bookings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.spaceTypeId = _data["spaceTypeId"];
            this.isEnabled = _data["isEnabled"];
            this.isLocked = _data["isLocked"];
            this.waveId = _data["waveId"];
            this.label = _data["label"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(SpaceBookingResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingSpaceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSpaceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["spaceTypeId"] = this.spaceTypeId;
        data["isEnabled"] = this.isEnabled;
        data["isLocked"] = this.isLocked;
        data["waveId"] = this.waveId;
        data["label"] = this.label;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBookingSpaceResponse {
    spaceId: string;
    spaceTypeId: string;
    isEnabled: boolean;
    isLocked: boolean;
    waveId: string;
    label: string;
    bookings: SpaceBookingResponse[];
}

export class BookingSpaceWorkStationResponse extends BookingSpaceResponse implements IBookingSpaceWorkStationResponse {
    workPlaceTypeId?: number | undefined;
    workStationTypeId!: number;
    hasLan?: boolean | undefined;
    isElevatedTable?: boolean | undefined;
    isWheelChairAccess?: boolean | undefined;
    extraSocketStrips?: boolean | undefined;
    bookedUserId?: number | undefined;

    constructor(data?: IBookingSpaceWorkStationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workPlaceTypeId = _data["workPlaceTypeId"];
            this.workStationTypeId = _data["workStationTypeId"];
            this.hasLan = _data["hasLan"];
            this.isElevatedTable = _data["isElevatedTable"];
            this.isWheelChairAccess = _data["isWheelChairAccess"];
            this.extraSocketStrips = _data["extraSocketStrips"];
            this.bookedUserId = _data["bookedUserId"];
        }
    }

    static fromJS(data: any): BookingSpaceWorkStationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSpaceWorkStationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workPlaceTypeId"] = this.workPlaceTypeId;
        data["workStationTypeId"] = this.workStationTypeId;
        data["hasLan"] = this.hasLan;
        data["isElevatedTable"] = this.isElevatedTable;
        data["isWheelChairAccess"] = this.isWheelChairAccess;
        data["extraSocketStrips"] = this.extraSocketStrips;
        data["bookedUserId"] = this.bookedUserId;
        super.toJSON(data);
        return data; 
    }
}

export interface IBookingSpaceWorkStationResponse extends IBookingSpaceResponse {
    workPlaceTypeId?: number | undefined;
    workStationTypeId: number;
    hasLan?: boolean | undefined;
    isElevatedTable?: boolean | undefined;
    isWheelChairAccess?: boolean | undefined;
    extraSocketStrips?: boolean | undefined;
    bookedUserId?: number | undefined;
}

export class BookingSpaceItem implements IBookingSpaceItem {
    bookingId!: string;
    bookingUserId?: string | undefined;
    shiftTypeId?: string | undefined;
    date?: Date | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isCancel!: boolean;

    constructor(data?: IBookingSpaceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.bookingUserId = _data["bookingUserId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.isCancel = _data["isCancel"];
        }
    }

    static fromJS(data: any): BookingSpaceItem {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSpaceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["bookingUserId"] = this.bookingUserId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["isCancel"] = this.isCancel;
        return data; 
    }
}

export interface IBookingSpaceItem {
    bookingId: string;
    bookingUserId?: string | undefined;
    shiftTypeId?: string | undefined;
    date?: Date | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isCancel: boolean;
}

export class SpaceBookingResponse extends BookingSpaceItem implements ISpaceBookingResponse {
    spaceId!: number;
    spaceTypeId!: number;

    constructor(data?: ISpaceBookingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.spaceTypeId = _data["spaceTypeId"];
        }
    }

    static fromJS(data: any): SpaceBookingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceBookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["spaceTypeId"] = this.spaceTypeId;
        super.toJSON(data);
        return data; 
    }
}

export interface ISpaceBookingResponse extends IBookingSpaceItem {
    spaceId: number;
    spaceTypeId: number;
}

export class BookingSpaceMeetingRoomResponse extends BookingSpaceResponse implements IBookingSpaceMeetingRoomResponse {
    allowedCapacity!: number;
    totalOccupancy!: number;
    externalVisitors!: boolean;
    hasLan?: boolean | undefined;
    hasAudio?: boolean | undefined;
    hasIntercom?: boolean | undefined;
    hasPresentationScreen?: boolean | undefined;
    hasCoffeeCorner?: boolean | undefined;
    hasWhiteboard?: boolean | undefined;
    hasVr?: boolean | undefined;

    constructor(data?: IBookingSpaceMeetingRoomResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allowedCapacity = _data["allowedCapacity"];
            this.totalOccupancy = _data["totalOccupancy"];
            this.externalVisitors = _data["externalVisitors"];
            this.hasLan = _data["hasLan"];
            this.hasAudio = _data["hasAudio"];
            this.hasIntercom = _data["hasIntercom"];
            this.hasPresentationScreen = _data["hasPresentationScreen"];
            this.hasCoffeeCorner = _data["hasCoffeeCorner"];
            this.hasWhiteboard = _data["hasWhiteboard"];
            this.hasVr = _data["hasVr"];
        }
    }

    static fromJS(data: any): BookingSpaceMeetingRoomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSpaceMeetingRoomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedCapacity"] = this.allowedCapacity;
        data["totalOccupancy"] = this.totalOccupancy;
        data["externalVisitors"] = this.externalVisitors;
        data["hasLan"] = this.hasLan;
        data["hasAudio"] = this.hasAudio;
        data["hasIntercom"] = this.hasIntercom;
        data["hasPresentationScreen"] = this.hasPresentationScreen;
        data["hasCoffeeCorner"] = this.hasCoffeeCorner;
        data["hasWhiteboard"] = this.hasWhiteboard;
        data["hasVr"] = this.hasVr;
        super.toJSON(data);
        return data; 
    }
}

export interface IBookingSpaceMeetingRoomResponse extends IBookingSpaceResponse {
    allowedCapacity: number;
    totalOccupancy: number;
    externalVisitors: boolean;
    hasLan?: boolean | undefined;
    hasAudio?: boolean | undefined;
    hasIntercom?: boolean | undefined;
    hasPresentationScreen?: boolean | undefined;
    hasCoffeeCorner?: boolean | undefined;
    hasWhiteboard?: boolean | undefined;
    hasVr?: boolean | undefined;
}

export class BookingUserResponse implements IBookingUserResponse {
    userId!: string;
    fullName!: string;
    imageUrl!: string;
    email!: string;
    langIsoCode!: string;

    constructor(data?: IBookingUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.imageUrl = _data["imageUrl"];
            this.email = _data["email"];
            this.langIsoCode = _data["langIsoCode"];
        }
    }

    static fromJS(data: any): BookingUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["imageUrl"] = this.imageUrl;
        data["email"] = this.email;
        data["langIsoCode"] = this.langIsoCode;
        return data; 
    }
}

export interface IBookingUserResponse {
    userId: string;
    fullName: string;
    imageUrl: string;
    email: string;
    langIsoCode: string;
}

export class BookingResponse implements IBookingResponse {
    id!: string;
    venueId!: string;
    venue!: string;
    buildingId!: string;
    building!: string;
    floorId!: string;
    floor!: string;
    shiftTypeId?: string | undefined;
    userId!: string;
    date!: Date;
    start!: string;
    end!: string;
    isCancel!: boolean;
    userInfoResponse!: BookingUserResponse;
    spaceResponse!: BookingSpaceResponse;

    constructor(data?: IBookingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userInfoResponse = new BookingUserResponse();
            this.spaceResponse = new BookingSpaceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.venueId = _data["venueId"];
            this.venue = _data["venue"];
            this.buildingId = _data["buildingId"];
            this.building = _data["building"];
            this.floorId = _data["floorId"];
            this.floor = _data["floor"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.isCancel = _data["isCancel"];
            this.userInfoResponse = _data["userInfoResponse"] ? BookingUserResponse.fromJS(_data["userInfoResponse"]) : new BookingUserResponse();
            this.spaceResponse = _data["spaceResponse"] ? BookingSpaceResponse.fromJS(_data["spaceResponse"]) : new BookingSpaceResponse();
        }
    }

    static fromJS(data: any): BookingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["venueId"] = this.venueId;
        data["venue"] = this.venue;
        data["buildingId"] = this.buildingId;
        data["building"] = this.building;
        data["floorId"] = this.floorId;
        data["floor"] = this.floor;
        data["shiftTypeId"] = this.shiftTypeId;
        data["userId"] = this.userId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["isCancel"] = this.isCancel;
        data["userInfoResponse"] = this.userInfoResponse ? this.userInfoResponse.toJSON() : <any>undefined;
        data["spaceResponse"] = this.spaceResponse ? this.spaceResponse.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBookingResponse {
    id: string;
    venueId: string;
    venue: string;
    buildingId: string;
    building: string;
    floorId: string;
    floor: string;
    shiftTypeId?: string | undefined;
    userId: string;
    date: Date;
    start: string;
    end: string;
    isCancel: boolean;
    userInfoResponse: BookingUserResponse;
    spaceResponse: BookingSpaceResponse;
}

export class PaginatedItemsOfBookingSearchResponse implements IPaginatedItemsOfBookingSearchResponse {
    pageIndex!: number;
    pageSize!: number;
    count!: number;
    pages!: number;
    data!: BookingSearchResponse[];

    constructor(data?: IPaginatedItemsOfBookingSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BookingSearchResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedItemsOfBookingSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedItemsOfBookingSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["count"] = this.count;
        data["pages"] = this.pages;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaginatedItemsOfBookingSearchResponse {
    pageIndex: number;
    pageSize: number;
    count: number;
    pages: number;
    data: BookingSearchResponse[];
}

export class BookingSearchResponse implements IBookingSearchResponse {
    bookingId!: string;
    bookingDate!: Date;
    start!: string;
    end!: string;
    userImageUrl!: string;
    userName!: string;
    venueName!: string;
    buildingName!: string;
    floorName!: string;
    spaceName!: string;
    spaceTypeName!: string;

    constructor(data?: IBookingSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.start = _data["start"];
            this.end = _data["end"];
            this.userImageUrl = _data["userImageUrl"];
            this.userName = _data["userName"];
            this.venueName = _data["venueName"];
            this.buildingName = _data["buildingName"];
            this.floorName = _data["floorName"];
            this.spaceName = _data["spaceName"];
            this.spaceTypeName = _data["spaceTypeName"];
        }
    }

    static fromJS(data: any): BookingSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["start"] = this.start;
        data["end"] = this.end;
        data["userImageUrl"] = this.userImageUrl;
        data["userName"] = this.userName;
        data["venueName"] = this.venueName;
        data["buildingName"] = this.buildingName;
        data["floorName"] = this.floorName;
        data["spaceName"] = this.spaceName;
        data["spaceTypeName"] = this.spaceTypeName;
        return data; 
    }
}

export interface IBookingSearchResponse {
    bookingId: string;
    bookingDate: Date;
    start: string;
    end: string;
    userImageUrl: string;
    userName: string;
    venueName: string;
    buildingName: string;
    floorName: string;
    spaceName: string;
    spaceTypeName: string;
}

export class SearchBookingModel implements ISearchBookingModel {
    pageIndex!: number;
    pageSize!: number;
    filters!: Filter[];
    sortBy!: Sort[];

    constructor(data?: ISearchBookingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
            this.sortBy = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(Sort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISearchBookingModel {
    pageIndex: number;
    pageSize: number;
    filters: Filter[];
    sortBy: Sort[];
}

export class Filter implements IFilter {
    id!: string;
    value!: string[];
    operator!: string;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["operator"] = this.operator;
        return data; 
    }
}

export interface IFilter {
    id: string;
    value: string[];
    operator: string;
}

export class Sort implements ISort {
    id!: string;
    desc!: boolean;

    constructor(data?: ISort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.desc = _data["desc"];
        }
    }

    static fromJS(data: any): Sort {
        data = typeof data === 'object' ? data : {};
        let result = new Sort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["desc"] = this.desc;
        return data; 
    }
}

export interface ISort {
    id: string;
    desc: boolean;
}

export class BuildingResponse implements IBuildingResponse {
    id!: string;
    name!: string;
    address!: string;
    city!: string;
    capacity!: number;
    limitedCapacity!: number;
    availableCapacity!: number;
    isPublished!: boolean;
    isClosed!: boolean;
    isArchived!: boolean;
    venueId!: string;
    venueName!: string;
    floorCount!: number;
    imageUrl!: string;
    activeActions!: BuildingAction[];

    constructor(data?: IBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.capacity = _data["capacity"];
            this.limitedCapacity = _data["limitedCapacity"];
            this.availableCapacity = _data["availableCapacity"];
            this.isPublished = _data["isPublished"];
            this.isClosed = _data["isClosed"];
            this.isArchived = _data["isArchived"];
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.floorCount = _data["floorCount"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["activeActions"])) {
                this.activeActions = [] as any;
                for (let item of _data["activeActions"])
                    this.activeActions!.push(BuildingAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["capacity"] = this.capacity;
        data["limitedCapacity"] = this.limitedCapacity;
        data["availableCapacity"] = this.availableCapacity;
        data["isPublished"] = this.isPublished;
        data["isClosed"] = this.isClosed;
        data["isArchived"] = this.isArchived;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["floorCount"] = this.floorCount;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.activeActions)) {
            data["activeActions"] = [];
            for (let item of this.activeActions)
                data["activeActions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBuildingResponse {
    id: string;
    name: string;
    address: string;
    city: string;
    capacity: number;
    limitedCapacity: number;
    availableCapacity: number;
    isPublished: boolean;
    isClosed: boolean;
    isArchived: boolean;
    venueId: string;
    venueName: string;
    floorCount: number;
    imageUrl: string;
    activeActions: BuildingAction[];
}

export class BuildingAction implements IBuildingAction {
    identifier!: number;
    name!: string;

    constructor(data?: IBuildingAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BuildingAction {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        return data; 
    }
}

export interface IBuildingAction {
    identifier: number;
    name: string;
}

export class CreateBuildingResponse implements ICreateBuildingResponse {
    id!: string;

    constructor(data?: ICreateBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateBuildingResponse {
    id: string;
}

export class CreateBuildingModel implements ICreateBuildingModel {
    name!: string;
    address!: string;
    city!: string;
    capacity!: number;
    limitedCapacity!: number;
    venueId!: string;
    imageUrl?: string | undefined;

    constructor(data?: ICreateBuildingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.capacity = _data["capacity"];
            this.limitedCapacity = _data["limitedCapacity"];
            this.venueId = _data["venueId"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): CreateBuildingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuildingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["capacity"] = this.capacity;
        data["limitedCapacity"] = this.limitedCapacity;
        data["venueId"] = this.venueId;
        data["imageUrl"] = this.imageUrl;
        return data; 
    }
}

export interface ICreateBuildingModel {
    name: string;
    address: string;
    city: string;
    capacity: number;
    limitedCapacity: number;
    venueId: string;
    imageUrl?: string | undefined;
}

export class UpdateBuildingResponse implements IUpdateBuildingResponse {
    id!: string;
    name!: string;
    address!: string;
    city!: string;
    capacity!: number;
    limitedCapacity!: number;
    isPublished!: boolean;
    isClosed!: boolean;
    image!: string;

    constructor(data?: IUpdateBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.capacity = _data["capacity"];
            this.limitedCapacity = _data["limitedCapacity"];
            this.isPublished = _data["isPublished"];
            this.isClosed = _data["isClosed"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UpdateBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["capacity"] = this.capacity;
        data["limitedCapacity"] = this.limitedCapacity;
        data["isPublished"] = this.isPublished;
        data["isClosed"] = this.isClosed;
        data["image"] = this.image;
        return data; 
    }
}

export interface IUpdateBuildingResponse {
    id: string;
    name: string;
    address: string;
    city: string;
    capacity: number;
    limitedCapacity: number;
    isPublished: boolean;
    isClosed: boolean;
    image: string;
}

export class UpdateBuildingModel implements IUpdateBuildingModel {
    name!: string;
    address!: string;
    city!: string;
    capacity!: number;
    limitedCapacity!: number;
    venueId!: string;
    imageUrl?: string | undefined;

    constructor(data?: IUpdateBuildingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.capacity = _data["capacity"];
            this.limitedCapacity = _data["limitedCapacity"];
            this.venueId = _data["venueId"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): UpdateBuildingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBuildingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["capacity"] = this.capacity;
        data["limitedCapacity"] = this.limitedCapacity;
        data["venueId"] = this.venueId;
        data["imageUrl"] = this.imageUrl;
        return data; 
    }
}

export interface IUpdateBuildingModel {
    name: string;
    address: string;
    city: string;
    capacity: number;
    limitedCapacity: number;
    venueId: string;
    imageUrl?: string | undefined;
}

export class CreateTermConditionResponse implements ICreateTermConditionResponse {
    url!: string;
    date!: Date;

    constructor(data?: ICreateTermConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTermConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTermConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreateTermConditionResponse {
    url: string;
    date: Date;
}

export class GetTermConditionResponse implements IGetTermConditionResponse {
    url!: string;
    date!: Date;

    constructor(data?: IGetTermConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTermConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTermConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetTermConditionResponse {
    url: string;
    date: Date;
}

export class AcceptedTermConditionResponse implements IAcceptedTermConditionResponse {
    success!: boolean;

    constructor(data?: IAcceptedTermConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AcceptedTermConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedTermConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data; 
    }
}

export interface IAcceptedTermConditionResponse {
    success: boolean;
}

export class DocumentResponse implements IDocumentResponse {
    id!: string;
    name!: string;
    url!: string;
    publishDate!: Date;

    constructor(data?: IDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDocumentResponse {
    id: string;
    name: string;
    url: string;
    publishDate: Date;
}

export class FloorResponse implements IFloorResponse {
    floorId!: string;
    name!: string;
    capacity!: number;
    workPlaces!: number;
    floorImageUrl!: string;
    isPublished!: boolean;
    isClosed!: boolean;
    isArchived!: boolean;
    lastUpdated!: Date;
    activeActions!: FloorAction[];

    constructor(data?: IFloorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"];
            this.name = _data["name"];
            this.capacity = _data["capacity"];
            this.workPlaces = _data["workPlaces"];
            this.floorImageUrl = _data["floorImageUrl"];
            this.isPublished = _data["isPublished"];
            this.isClosed = _data["isClosed"];
            this.isArchived = _data["isArchived"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            if (Array.isArray(_data["activeActions"])) {
                this.activeActions = [] as any;
                for (let item of _data["activeActions"])
                    this.activeActions!.push(FloorAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FloorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FloorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId;
        data["name"] = this.name;
        data["capacity"] = this.capacity;
        data["workPlaces"] = this.workPlaces;
        data["floorImageUrl"] = this.floorImageUrl;
        data["isPublished"] = this.isPublished;
        data["isClosed"] = this.isClosed;
        data["isArchived"] = this.isArchived;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (Array.isArray(this.activeActions)) {
            data["activeActions"] = [];
            for (let item of this.activeActions)
                data["activeActions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFloorResponse {
    floorId: string;
    name: string;
    capacity: number;
    workPlaces: number;
    floorImageUrl: string;
    isPublished: boolean;
    isClosed: boolean;
    isArchived: boolean;
    lastUpdated: Date;
    activeActions: FloorAction[];
}

export class FloorAction implements IFloorAction {
    identifier!: number;
    name!: string;

    constructor(data?: IFloorAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FloorAction {
        data = typeof data === 'object' ? data : {};
        let result = new FloorAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        return data; 
    }
}

export interface IFloorAction {
    identifier: number;
    name: string;
}

export class FloorDetailResponse implements IFloorDetailResponse {
    organizationId!: string;
    venueId!: string;
    venueName!: string;
    buildingId!: string;
    buildingName!: string;
    floorId!: string;
    name!: string;
    planeModelUrl!: string;
    sceneMetadata!: string;
    imageModelUrl!: string;
    isDraft!: boolean;
    isPublished!: boolean;
    isClosed!: boolean;
    isArchived!: boolean;
    workPlaces!: number;
    hasActiveBookings!: boolean;

    constructor(data?: IFloorDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.floorId = _data["floorId"];
            this.name = _data["name"];
            this.planeModelUrl = _data["planeModelUrl"];
            this.sceneMetadata = _data["sceneMetadata"];
            this.imageModelUrl = _data["imageModelUrl"];
            this.isDraft = _data["isDraft"];
            this.isPublished = _data["isPublished"];
            this.isClosed = _data["isClosed"];
            this.isArchived = _data["isArchived"];
            this.workPlaces = _data["workPlaces"];
            this.hasActiveBookings = _data["hasActiveBookings"];
        }
    }

    static fromJS(data: any): FloorDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FloorDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["floorId"] = this.floorId;
        data["name"] = this.name;
        data["planeModelUrl"] = this.planeModelUrl;
        data["sceneMetadata"] = this.sceneMetadata;
        data["imageModelUrl"] = this.imageModelUrl;
        data["isDraft"] = this.isDraft;
        data["isPublished"] = this.isPublished;
        data["isClosed"] = this.isClosed;
        data["isArchived"] = this.isArchived;
        data["workPlaces"] = this.workPlaces;
        data["hasActiveBookings"] = this.hasActiveBookings;
        return data; 
    }
}

export interface IFloorDetailResponse {
    organizationId: string;
    venueId: string;
    venueName: string;
    buildingId: string;
    buildingName: string;
    floorId: string;
    name: string;
    planeModelUrl: string;
    sceneMetadata: string;
    imageModelUrl: string;
    isDraft: boolean;
    isPublished: boolean;
    isClosed: boolean;
    isArchived: boolean;
    workPlaces: number;
    hasActiveBookings: boolean;
}

export class FloorPlanResponse implements IFloorPlanResponse {
    organizationId!: string;
    venueId!: string;
    buildingId!: string;
    floorId!: string;
    url!: string;
    sceneMetadata!: string;

    constructor(data?: IFloorPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.venueId = _data["venueId"];
            this.buildingId = _data["buildingId"];
            this.floorId = _data["floorId"];
            this.url = _data["url"];
            this.sceneMetadata = _data["sceneMetadata"];
        }
    }

    static fromJS(data: any): FloorPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FloorPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["venueId"] = this.venueId;
        data["buildingId"] = this.buildingId;
        data["floorId"] = this.floorId;
        data["url"] = this.url;
        data["sceneMetadata"] = this.sceneMetadata;
        return data; 
    }
}

export interface IFloorPlanResponse {
    organizationId: string;
    venueId: string;
    buildingId: string;
    floorId: string;
    url: string;
    sceneMetadata: string;
}

export class CreateFloorResponse implements ICreateFloorResponse {
    id!: string;
    name!: string;

    constructor(data?: ICreateFloorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFloorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFloorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateFloorResponse {
    id: string;
    name: string;
}

export class CreateFloorModel implements ICreateFloorModel {
    name!: string;
    buildingId!: string;

    constructor(data?: ICreateFloorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): CreateFloorModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFloorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        return data; 
    }
}

export interface ICreateFloorModel {
    name: string;
    buildingId: string;
}

export class UpdateFloorResponse implements IUpdateFloorResponse {
    id!: string;
    name!: string;
    isPublished!: boolean;
    isClosed!: boolean;
    buildingId!: string;

    constructor(data?: IUpdateFloorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isPublished = _data["isPublished"];
            this.isClosed = _data["isClosed"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): UpdateFloorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFloorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPublished"] = this.isPublished;
        data["isClosed"] = this.isClosed;
        data["buildingId"] = this.buildingId;
        return data; 
    }
}

export interface IUpdateFloorResponse {
    id: string;
    name: string;
    isPublished: boolean;
    isClosed: boolean;
    buildingId: string;
}

export class UpdateFloorModel implements IUpdateFloorModel {
    name!: string;

    constructor(data?: IUpdateFloorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateFloorModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFloorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateFloorModel {
    name: string;
}

export class UploadFloorPlanResponse implements IUploadFloorPlanResponse {
    floorId!: string;
    planModelUrl!: string;
    imagePlanUrl!: string;

    constructor(data?: IUploadFloorPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"];
            this.planModelUrl = _data["planModelUrl"];
            this.imagePlanUrl = _data["imagePlanUrl"];
        }
    }

    static fromJS(data: any): UploadFloorPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFloorPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId;
        data["planModelUrl"] = this.planModelUrl;
        data["imagePlanUrl"] = this.imagePlanUrl;
        return data; 
    }
}

export interface IUploadFloorPlanResponse {
    floorId: string;
    planModelUrl: string;
    imagePlanUrl: string;
}

export class FloorplanMetadata implements IFloorplanMetadata {
    camera!: Camera;
    entities!: Entity[];

    constructor(data?: IFloorplanMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.camera = new Camera();
            this.entities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.camera = _data["camera"] ? Camera.fromJS(_data["camera"]) : new Camera();
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FloorplanMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new FloorplanMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["camera"] = this.camera ? this.camera.toJSON() : <any>undefined;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFloorplanMetadata {
    camera: Camera;
    entities: Entity[];
}

export class Camera implements ICamera {
    backgroundColor!: string;
    position!: Vector3;
    projectionMode!: number;
    projectionWidth!: number;
    rotation!: Vector3;

    constructor(data?: ICamera) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Vector3();
            this.rotation = new Vector3();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.position = _data["position"] ? Vector3.fromJS(_data["position"]) : new Vector3();
            this.projectionMode = _data["projectionMode"];
            this.projectionWidth = _data["projectionWidth"];
            this.rotation = _data["rotation"] ? Vector3.fromJS(_data["rotation"]) : new Vector3();
        }
    }

    static fromJS(data: any): Camera {
        data = typeof data === 'object' ? data : {};
        let result = new Camera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["projectionMode"] = this.projectionMode;
        data["projectionWidth"] = this.projectionWidth;
        data["rotation"] = this.rotation ? this.rotation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICamera {
    backgroundColor: string;
    position: Vector3;
    projectionMode: number;
    projectionWidth: number;
    rotation: Vector3;
}

export class Vector3 implements IVector3 {
    x!: number;
    y!: number;
    z!: number;

    constructor(data?: IVector3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Vector3 {
        data = typeof data === 'object' ? data : {};
        let result = new Vector3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data; 
    }
}

export interface IVector3 {
    x: number;
    y: number;
    z: number;
}

export class Entity implements IEntity {
    id!: string;
    name!: string;
    color!: string;
    isRenderable!: boolean;
    isInteractable!: boolean;
    position!: Vector3;
    scale!: Vector3;
    angle!: number;
    shapeType!: string;
    properties!: { [key: string]: string; };

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Vector3();
            this.scale = new Vector3();
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.isRenderable = _data["isRenderable"];
            this.isInteractable = _data["isInteractable"];
            this.position = _data["position"] ? Vector3.fromJS(_data["position"]) : new Vector3();
            this.scale = _data["scale"] ? Vector3.fromJS(_data["scale"]) : new Vector3();
            this.angle = _data["angle"];
            this.shapeType = _data["shapeType"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["isRenderable"] = this.isRenderable;
        data["isInteractable"] = this.isInteractable;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["scale"] = this.scale ? this.scale.toJSON() : <any>undefined;
        data["angle"] = this.angle;
        data["shapeType"] = this.shapeType;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface IEntity {
    id: string;
    name: string;
    color: string;
    isRenderable: boolean;
    isInteractable: boolean;
    position: Vector3;
    scale: Vector3;
    angle: number;
    shapeType: string;
    properties: { [key: string]: string; };
}

export class GetFloorplanMetadataResponse implements IGetFloorplanMetadataResponse {
    venueId!: string;
    venueName!: string;
    buildingId!: string;
    buildingName!: string;
    floorId!: string;
    floorName!: string;
    modelUrl!: string;
    leyendUrl!: string;
    camera!: Camera;
    entities!: Entity[];
    infoEntities!: InfoEntity[];

    constructor(data?: IGetFloorplanMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.camera = new Camera();
            this.entities = [];
            this.infoEntities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.venueId = _data["venueId"];
            this.venueName = _data["venueName"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.floorId = _data["floorId"];
            this.floorName = _data["floorName"];
            this.modelUrl = _data["modelUrl"];
            this.leyendUrl = _data["leyendUrl"];
            this.camera = _data["camera"] ? Camera.fromJS(_data["camera"]) : new Camera();
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
            if (Array.isArray(_data["infoEntities"])) {
                this.infoEntities = [] as any;
                for (let item of _data["infoEntities"])
                    this.infoEntities!.push(InfoEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFloorplanMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFloorplanMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["venueId"] = this.venueId;
        data["venueName"] = this.venueName;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["floorId"] = this.floorId;
        data["floorName"] = this.floorName;
        data["modelUrl"] = this.modelUrl;
        data["leyendUrl"] = this.leyendUrl;
        data["camera"] = this.camera ? this.camera.toJSON() : <any>undefined;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        if (Array.isArray(this.infoEntities)) {
            data["infoEntities"] = [];
            for (let item of this.infoEntities)
                data["infoEntities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetFloorplanMetadataResponse {
    venueId: string;
    venueName: string;
    buildingId: string;
    buildingName: string;
    floorId: string;
    floorName: string;
    modelUrl: string;
    leyendUrl: string;
    camera: Camera;
    entities: Entity[];
    infoEntities: InfoEntity[];
}

export class InfoEntity implements IInfoEntity {
    waveId!: string;
    spaceId!: string;
    hasActiveBookings!: boolean;

    constructor(data?: IInfoEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waveId = _data["waveId"];
            this.spaceId = _data["spaceId"];
            this.hasActiveBookings = _data["hasActiveBookings"];
        }
    }

    static fromJS(data: any): InfoEntity {
        data = typeof data === 'object' ? data : {};
        let result = new InfoEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waveId"] = this.waveId;
        data["spaceId"] = this.spaceId;
        data["hasActiveBookings"] = this.hasActiveBookings;
        return data; 
    }
}

export interface IInfoEntity {
    waveId: string;
    spaceId: string;
    hasActiveBookings: boolean;
}

export class IncidentTypeResponse implements IIncidentTypeResponse {
    id!: string;
    name!: string;
    reportCode!: string;

    constructor(data?: IIncidentTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.reportCode = _data["reportCode"];
        }
    }

    static fromJS(data: any): IncidentTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["reportCode"] = this.reportCode;
        return data; 
    }
}

export interface IIncidentTypeResponse {
    id: string;
    name: string;
    reportCode: string;
}

export class IncidentProductResponse implements IIncidentProductResponse {
    id!: string;
    name!: string;
    incidentTypeId!: string;

    constructor(data?: IIncidentProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.incidentTypeId = _data["incidentTypeId"];
        }
    }

    static fromJS(data: any): IncidentProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["incidentTypeId"] = this.incidentTypeId;
        return data; 
    }
}

export interface IIncidentProductResponse {
    id: string;
    name: string;
    incidentTypeId: string;
}

export class IncidentReponse implements IIncidentReponse {
    id!: string;
    floorId!: string;
    userId!: string;
    incidentTypeId!: string;
    place!: string;
    description!: string;
    date?: Date | undefined;
    userName!: string;
    venueName!: string;
    buildingName!: string;
    floorName!: string;
    products!: IncidentProductRespone[];

    constructor(data?: IIncidentReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.floorId = _data["floorId"];
            this.userId = _data["userId"];
            this.incidentTypeId = _data["incidentTypeId"];
            this.place = _data["place"];
            this.description = _data["description"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.venueName = _data["venueName"];
            this.buildingName = _data["buildingName"];
            this.floorName = _data["floorName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(IncidentProductRespone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentReponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["floorId"] = this.floorId;
        data["userId"] = this.userId;
        data["incidentTypeId"] = this.incidentTypeId;
        data["place"] = this.place;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["venueName"] = this.venueName;
        data["buildingName"] = this.buildingName;
        data["floorName"] = this.floorName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncidentReponse {
    id: string;
    floorId: string;
    userId: string;
    incidentTypeId: string;
    place: string;
    description: string;
    date?: Date | undefined;
    userName: string;
    venueName: string;
    buildingName: string;
    floorName: string;
    products: IncidentProductRespone[];
}

export class IncidentProductRespone implements IIncidentProductRespone {
    productId!: string;
    productName!: string;
    resolved!: boolean;

    constructor(data?: IIncidentProductRespone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.resolved = _data["resolved"];
        }
    }

    static fromJS(data: any): IncidentProductRespone {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentProductRespone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["resolved"] = this.resolved;
        return data; 
    }
}

export interface IIncidentProductRespone {
    productId: string;
    productName: string;
    resolved: boolean;
}

export class CreateMeIncidentResponse implements ICreateMeIncidentResponse {
    id!: string;

    constructor(data?: ICreateMeIncidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateMeIncidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeIncidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateMeIncidentResponse {
    id: string;
}

export class CreateIncidentReportModel implements ICreateIncidentReportModel {
    floorId!: string;
    place!: string;
    incidentReportTypeId!: string;
    description?: string | undefined;
    products!: ProductModel[];

    constructor(data?: ICreateIncidentReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"];
            this.place = _data["place"];
            this.incidentReportTypeId = _data["incidentReportTypeId"];
            this.description = _data["description"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIncidentReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId;
        data["place"] = this.place;
        data["incidentReportTypeId"] = this.incidentReportTypeId;
        data["description"] = this.description;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateIncidentReportModel {
    floorId: string;
    place: string;
    incidentReportTypeId: string;
    description?: string | undefined;
    products: ProductModel[];
}

export class ProductModel implements IProductModel {
    productId!: string;

    constructor(data?: IProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IProductModel {
    productId: string;
}

export class ResolveIncidentResponse implements IResolveIncidentResponse {
    id!: string;
    resolutionDate!: Date;

    constructor(data?: IResolveIncidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resolutionDate = _data["resolutionDate"] ? new Date(_data["resolutionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResolveIncidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveIncidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resolutionDate"] = this.resolutionDate ? this.resolutionDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IResolveIncidentResponse {
    id: string;
    resolutionDate: Date;
}

export class PaginatedItemsOfIncidentSearchReponse implements IPaginatedItemsOfIncidentSearchReponse {
    pageIndex!: number;
    pageSize!: number;
    count!: number;
    pages!: number;
    data!: IncidentSearchReponse[];

    constructor(data?: IPaginatedItemsOfIncidentSearchReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncidentSearchReponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedItemsOfIncidentSearchReponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedItemsOfIncidentSearchReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["count"] = this.count;
        data["pages"] = this.pages;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaginatedItemsOfIncidentSearchReponse {
    pageIndex: number;
    pageSize: number;
    count: number;
    pages: number;
    data: IncidentSearchReponse[];
}

export class IncidentSearchReponse implements IIncidentSearchReponse {
    incidentTypeId!: string;
    reportId!: string;
    productId!: string;
    incidentDate!: Date;
    userName!: string;
    userImageUrl!: string;
    productName!: string;
    venueName!: string;
    buildingName!: string;
    floorName!: string;
    place!: string;
    resolved!: boolean;
    registerDate?: Date | undefined;

    constructor(data?: IIncidentSearchReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentTypeId = _data["incidentTypeId"];
            this.reportId = _data["reportId"];
            this.productId = _data["productId"];
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.userImageUrl = _data["userImageUrl"];
            this.productName = _data["productName"];
            this.venueName = _data["venueName"];
            this.buildingName = _data["buildingName"];
            this.floorName = _data["floorName"];
            this.place = _data["place"];
            this.resolved = _data["resolved"];
            this.registerDate = _data["registerDate"] ? new Date(_data["registerDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentSearchReponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentSearchReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentTypeId"] = this.incidentTypeId;
        data["reportId"] = this.reportId;
        data["productId"] = this.productId;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["userImageUrl"] = this.userImageUrl;
        data["productName"] = this.productName;
        data["venueName"] = this.venueName;
        data["buildingName"] = this.buildingName;
        data["floorName"] = this.floorName;
        data["place"] = this.place;
        data["resolved"] = this.resolved;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIncidentSearchReponse {
    incidentTypeId: string;
    reportId: string;
    productId: string;
    incidentDate: Date;
    userName: string;
    userImageUrl: string;
    productName: string;
    venueName: string;
    buildingName: string;
    floorName: string;
    place: string;
    resolved: boolean;
    registerDate?: Date | undefined;
}

export class SearchIncidentModel implements ISearchIncidentModel {
    pageIndex!: number;
    pageSize!: number;
    filters!: Filter[];
    sortBy!: Sort[];

    constructor(data?: ISearchIncidentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
            this.sortBy = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(Sort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchIncidentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchIncidentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISearchIncidentModel {
    pageIndex: number;
    pageSize: number;
    filters: Filter[];
    sortBy: Sort[];
}

export class RegisterMobileDeviceModel implements IRegisterMobileDeviceModel {
    deviceToken!: string;

    constructor(data?: IRegisterMobileDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceToken = _data["deviceToken"];
        }
    }

    static fromJS(data: any): RegisterMobileDeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterMobileDeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceToken"] = this.deviceToken;
        return data; 
    }
}

export interface IRegisterMobileDeviceModel {
    deviceToken: string;
}

export class CreatePrivacyPolicyResponse implements ICreatePrivacyPolicyResponse {
    url!: string;
    date!: Date;

    constructor(data?: ICreatePrivacyPolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePrivacyPolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrivacyPolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreatePrivacyPolicyResponse {
    url: string;
    date: Date;
}

export class GetPrivacyPolicyResponse implements IGetPrivacyPolicyResponse {
    url!: string;
    date!: Date;

    constructor(data?: IGetPrivacyPolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPrivacyPolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrivacyPolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetPrivacyPolicyResponse {
    url: string;
    date: Date;
}

export class AcceptedPrivacyPolicyResponse implements IAcceptedPrivacyPolicyResponse {
    success!: boolean;

    constructor(data?: IAcceptedPrivacyPolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AcceptedPrivacyPolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedPrivacyPolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data; 
    }
}

export interface IAcceptedPrivacyPolicyResponse {
    success: boolean;
}

export class GetUserProfileResponse implements IGetUserProfileResponse {
    id!: string;
    language!: string;
    userName!: string;
    email!: string;
    phone!: string;
    imageUrl?: string | undefined;
    defaultVenueId?: string | undefined;
    defaultBuildingId?: string | undefined;
    defaultFloorId?: string | undefined;
    isRiskPerson?: boolean | undefined;
    pushNotifications?: boolean | undefined;
    isActive!: boolean;
    acceptedPrivacyDate?: Date | undefined;
    acceptedTermConditionDate?: Date | undefined;
    rol!: string;

    constructor(data?: IGetUserProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.imageUrl = _data["imageUrl"];
            this.defaultVenueId = _data["defaultVenueId"];
            this.defaultBuildingId = _data["defaultBuildingId"];
            this.defaultFloorId = _data["defaultFloorId"];
            this.isRiskPerson = _data["isRiskPerson"];
            this.pushNotifications = _data["pushNotifications"];
            this.isActive = _data["isActive"];
            this.acceptedPrivacyDate = _data["acceptedPrivacyDate"] ? new Date(_data["acceptedPrivacyDate"].toString()) : <any>undefined;
            this.acceptedTermConditionDate = _data["acceptedTermConditionDate"] ? new Date(_data["acceptedTermConditionDate"].toString()) : <any>undefined;
            this.rol = _data["rol"];
        }
    }

    static fromJS(data: any): GetUserProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["imageUrl"] = this.imageUrl;
        data["defaultVenueId"] = this.defaultVenueId;
        data["defaultBuildingId"] = this.defaultBuildingId;
        data["defaultFloorId"] = this.defaultFloorId;
        data["isRiskPerson"] = this.isRiskPerson;
        data["pushNotifications"] = this.pushNotifications;
        data["isActive"] = this.isActive;
        data["acceptedPrivacyDate"] = this.acceptedPrivacyDate ? this.acceptedPrivacyDate.toISOString() : <any>undefined;
        data["acceptedTermConditionDate"] = this.acceptedTermConditionDate ? this.acceptedTermConditionDate.toISOString() : <any>undefined;
        data["rol"] = this.rol;
        return data; 
    }
}

export interface IGetUserProfileResponse {
    id: string;
    language: string;
    userName: string;
    email: string;
    phone: string;
    imageUrl?: string | undefined;
    defaultVenueId?: string | undefined;
    defaultBuildingId?: string | undefined;
    defaultFloorId?: string | undefined;
    isRiskPerson?: boolean | undefined;
    pushNotifications?: boolean | undefined;
    isActive: boolean;
    acceptedPrivacyDate?: Date | undefined;
    acceptedTermConditionDate?: Date | undefined;
    rol: string;
}

export class UpdateProfileModel implements IUpdateProfileModel {
    language?: string | undefined;
    riskPerson?: boolean | undefined;
    venueId?: string | undefined;
    buildingId?: string | undefined;
    floorId?: string | undefined;
    phone?: string | undefined;
    pushNotification?: boolean | undefined;

    constructor(data?: IUpdateProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.riskPerson = _data["riskPerson"];
            this.venueId = _data["venueId"];
            this.buildingId = _data["buildingId"];
            this.floorId = _data["floorId"];
            this.phone = _data["phone"];
            this.pushNotification = _data["pushNotification"];
        }
    }

    static fromJS(data: any): UpdateProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["riskPerson"] = this.riskPerson;
        data["venueId"] = this.venueId;
        data["buildingId"] = this.buildingId;
        data["floorId"] = this.floorId;
        data["phone"] = this.phone;
        data["pushNotification"] = this.pushNotification;
        return data; 
    }
}

export interface IUpdateProfileModel {
    language?: string | undefined;
    riskPerson?: boolean | undefined;
    venueId?: string | undefined;
    buildingId?: string | undefined;
    floorId?: string | undefined;
    phone?: string | undefined;
    pushNotification?: boolean | undefined;
}

export class UserResponse implements IUserResponse {
    id!: string;
    name!: string;
    email!: string;
    isActive!: boolean;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUserResponse {
    id: string;
    name: string;
    email: string;
    isActive: boolean;
}

export class PatchIsActiveUserProfileModel implements IPatchIsActiveUserProfileModel {
    isActive!: boolean;

    constructor(data?: IPatchIsActiveUserProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PatchIsActiveUserProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatchIsActiveUserProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IPatchIsActiveUserProfileModel {
    isActive: boolean;
}

export class ReportResponse implements IReportResponse {
    id!: string;
    name!: string;
    reportId!: string;
    workspaceId!: string;

    constructor(data?: IReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.reportId = _data["reportId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): ReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["reportId"] = this.reportId;
        data["workspaceId"] = this.workspaceId;
        return data; 
    }
}

export interface IReportResponse {
    id: string;
    name: string;
    reportId: string;
    workspaceId: string;
}

export class EmbedParams implements IEmbedParams {
    type!: string;
    embedReports!: EmbedReport[];
    embedToken!: string;

    constructor(data?: IEmbedParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.embedReports = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["embedReports"])) {
                this.embedReports = [] as any;
                for (let item of _data["embedReports"])
                    this.embedReports!.push(EmbedReport.fromJS(item));
            }
            this.embedToken = _data["embedToken"];
        }
    }

    static fromJS(data: any): EmbedParams {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.embedReports)) {
            data["embedReports"] = [];
            for (let item of this.embedReports)
                data["embedReports"].push(item.toJSON());
        }
        data["embedToken"] = this.embedToken;
        return data; 
    }
}

export interface IEmbedParams {
    type: string;
    embedReports: EmbedReport[];
    embedToken: string;
}

export class GetReportParamsResponse extends EmbedParams implements IGetReportParamsResponse {

    constructor(data?: IGetReportParamsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetReportParamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportParamsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IGetReportParamsResponse extends IEmbedParams {
}

export class EmbedReport implements IEmbedReport {
    reportId!: string;
    reportName!: string;
    embedUrl!: string;

    constructor(data?: IEmbedReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.embedUrl = _data["embedUrl"];
        }
    }

    static fromJS(data: any): EmbedReport {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["embedUrl"] = this.embedUrl;
        return data; 
    }
}

export interface IEmbedReport {
    reportId: string;
    reportName: string;
    embedUrl: string;
}

export class PaginatedItemsOfSearchRiskPersonResponse implements IPaginatedItemsOfSearchRiskPersonResponse {
    pageIndex!: number;
    pageSize!: number;
    count!: number;
    pages!: number;
    data!: SearchRiskPersonResponse[];

    constructor(data?: IPaginatedItemsOfSearchRiskPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SearchRiskPersonResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedItemsOfSearchRiskPersonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedItemsOfSearchRiskPersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["count"] = this.count;
        data["pages"] = this.pages;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaginatedItemsOfSearchRiskPersonResponse {
    pageIndex: number;
    pageSize: number;
    count: number;
    pages: number;
    data: SearchRiskPersonResponse[];
}

export class SearchRiskPersonResponse implements ISearchRiskPersonResponse {
    userId!: string;
    userName!: string;
    userImageUrl!: string;
    venueName!: string;
    buildingName!: string;
    floorName!: string;
    lastBookingDate?: Date | undefined;

    constructor(data?: ISearchRiskPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userImageUrl = _data["userImageUrl"];
            this.venueName = _data["venueName"];
            this.buildingName = _data["buildingName"];
            this.floorName = _data["floorName"];
            this.lastBookingDate = _data["lastBookingDate"] ? new Date(_data["lastBookingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchRiskPersonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRiskPersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userImageUrl"] = this.userImageUrl;
        data["venueName"] = this.venueName;
        data["buildingName"] = this.buildingName;
        data["floorName"] = this.floorName;
        data["lastBookingDate"] = this.lastBookingDate ? this.lastBookingDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISearchRiskPersonResponse {
    userId: string;
    userName: string;
    userImageUrl: string;
    venueName: string;
    buildingName: string;
    floorName: string;
    lastBookingDate?: Date | undefined;
}

export class SearchRiskPersonModel implements ISearchRiskPersonModel {
    pageIndex!: number;
    pageSize!: number;
    filters!: Filter[];
    sortBy!: Sort[];

    constructor(data?: ISearchRiskPersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
            this.sortBy = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(Sort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchRiskPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRiskPersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISearchRiskPersonModel {
    pageIndex: number;
    pageSize: number;
    filters: Filter[];
    sortBy: Sort[];
}

export class CreateSampleResponse implements ICreateSampleResponse {
    id!: string;

    constructor(data?: ICreateSampleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSampleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSampleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateSampleResponse {
    id: string;
}

export class CreateSampleModel implements ICreateSampleModel {
    name!: string;

    constructor(data?: ICreateSampleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSampleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSampleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateSampleModel {
    name: string;
}

export class UpdateSampleResponse implements IUpdateSampleResponse {
    id!: string;
    name!: string;

    constructor(data?: IUpdateSampleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateSampleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSampleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateSampleResponse {
    id: string;
    name: string;
}

export class UpdateSampleModel implements IUpdateSampleModel {
    name!: string;

    constructor(data?: IUpdateSampleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateSampleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSampleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateSampleModel {
    name: string;
}

export class ShiftTypeResponse implements IShiftTypeResponse {
    id!: string;
    name!: string;

    constructor(data?: IShiftTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ShiftTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IShiftTypeResponse {
    id: string;
    name: string;
}

export class SpaceTypeResponse implements ISpaceTypeResponse {
    id!: string;
    name!: string;

    constructor(data?: ISpaceTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SpaceTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISpaceTypeResponse {
    id: string;
    name: string;
}

export class SurveyDefinitionResponse implements ISurveyDefinitionResponse {
    id!: string;
    name!: string;
    questions!: SurveyQuestionDefinitionResponse[];

    constructor(data?: ISurveyDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestionDefinitionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurveyDefinitionResponse {
    id: string;
    name: string;
    questions: SurveyQuestionDefinitionResponse[];
}

export class SurveyQuestionDefinitionResponse implements ISurveyQuestionDefinitionResponse {
    questionId!: string;
    question!: string;
    inputType!: number;
    required!: boolean;

    constructor(data?: ISurveyQuestionDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.question = _data["question"];
            this.inputType = _data["inputType"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): SurveyQuestionDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["question"] = this.question;
        data["inputType"] = this.inputType;
        data["required"] = this.required;
        return data; 
    }
}

export interface ISurveyQuestionDefinitionResponse {
    questionId: string;
    question: string;
    inputType: number;
    required: boolean;
}

export class CreateHealthSurveyResponse implements ICreateHealthSurveyResponse {
    id!: string;

    constructor(data?: ICreateHealthSurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateHealthSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateHealthSurveyResponse {
    id: string;
}

export class CreateHealthSurveyModel implements ICreateHealthSurveyModel {
    questionId!: string;
    value!: string;

    constructor(data?: ICreateHealthSurveyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateHealthSurveyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthSurveyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["value"] = this.value;
        return data; 
    }
}

export interface ICreateHealthSurveyModel {
    questionId: string;
    value: string;
}

export class SurveyResponse implements ISurveyResponse {
    id!: string;
    name!: string;
    answers!: SurveyAnswerResponse[];

    constructor(data?: ISurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurveyResponse {
    id: string;
    name: string;
    answers: SurveyAnswerResponse[];
}

export class SurveyAnswerResponse implements ISurveyAnswerResponse {
    questionId!: string;
    inputTypeId!: string;
    value!: string;

    constructor(data?: ISurveyAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.inputTypeId = _data["inputTypeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SurveyAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["inputTypeId"] = this.inputTypeId;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISurveyAnswerResponse {
    questionId: string;
    inputTypeId: string;
    value: string;
}

export class CreateFeelingSurveyResponse implements ICreateFeelingSurveyResponse {
    id!: string;

    constructor(data?: ICreateFeelingSurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFeelingSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeelingSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateFeelingSurveyResponse {
    id: string;
}

export class CreateFeelingSurveyModel implements ICreateFeelingSurveyModel {
    feelingValue!: number;

    constructor(data?: ICreateFeelingSurveyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feelingValue = _data["feelingValue"];
        }
    }

    static fromJS(data: any): CreateFeelingSurveyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeelingSurveyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feelingValue"] = this.feelingValue;
        return data; 
    }
}

export interface ICreateFeelingSurveyModel {
    feelingValue: number;
}

export class SurveyFeelingResponse implements ISurveyFeelingResponse {
    feelingValue!: number;
    date!: Date;

    constructor(data?: ISurveyFeelingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feelingValue = _data["feelingValue"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyFeelingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyFeelingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feelingValue"] = this.feelingValue;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISurveyFeelingResponse {
    feelingValue: number;
    date: Date;
}

export class CreateCovid19SurveyResponse implements ICreateCovid19SurveyResponse {
    id!: string;

    constructor(data?: ICreateCovid19SurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCovid19SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCovid19SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateCovid19SurveyResponse {
    id: string;
}

export class CreateCovid19SurveyModel implements ICreateCovid19SurveyModel {
    isPositive!: boolean;

    constructor(data?: ICreateCovid19SurveyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPositive = _data["isPositive"];
        }
    }

    static fromJS(data: any): CreateCovid19SurveyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCovid19SurveyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPositive"] = this.isPositive;
        return data; 
    }
}

export interface ICreateCovid19SurveyModel {
    isPositive: boolean;
}

export class SurveyCovid19Response implements ISurveyCovid19Response {
    isPositive!: number;
    date!: Date;

    constructor(data?: ISurveyCovid19Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPositive = _data["isPositive"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyCovid19Response {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCovid19Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPositive"] = this.isPositive;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISurveyCovid19Response {
    isPositive: number;
    date: Date;
}

export class PaginatedItemsOfSurveyCovid19SearchResponse implements IPaginatedItemsOfSurveyCovid19SearchResponse {
    pageIndex!: number;
    pageSize!: number;
    count!: number;
    pages!: number;
    data!: SurveyCovid19SearchResponse[];

    constructor(data?: IPaginatedItemsOfSurveyCovid19SearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SurveyCovid19SearchResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedItemsOfSurveyCovid19SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedItemsOfSurveyCovid19SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["count"] = this.count;
        data["pages"] = this.pages;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaginatedItemsOfSurveyCovid19SearchResponse {
    pageIndex: number;
    pageSize: number;
    count: number;
    pages: number;
    data: SurveyCovid19SearchResponse[];
}

export class SurveyCovid19SearchResponse implements ISurveyCovid19SearchResponse {
    surveyId!: string;
    userName!: string;
    userImageUrl!: string;
    venueName!: string;
    buildingName!: string;
    floorName!: string;
    lastBookingDate?: Date | undefined;
    registerDate?: Date | undefined;

    constructor(data?: ISurveyCovid19SearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.userName = _data["userName"];
            this.userImageUrl = _data["userImageUrl"];
            this.venueName = _data["venueName"];
            this.buildingName = _data["buildingName"];
            this.floorName = _data["floorName"];
            this.lastBookingDate = _data["lastBookingDate"] ? new Date(_data["lastBookingDate"].toString()) : <any>undefined;
            this.registerDate = _data["registerDate"] ? new Date(_data["registerDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyCovid19SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCovid19SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["userName"] = this.userName;
        data["userImageUrl"] = this.userImageUrl;
        data["venueName"] = this.venueName;
        data["buildingName"] = this.buildingName;
        data["floorName"] = this.floorName;
        data["lastBookingDate"] = this.lastBookingDate ? this.lastBookingDate.toISOString() : <any>undefined;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISurveyCovid19SearchResponse {
    surveyId: string;
    userName: string;
    userImageUrl: string;
    venueName: string;
    buildingName: string;
    floorName: string;
    lastBookingDate?: Date | undefined;
    registerDate?: Date | undefined;
}

export class SearchCovid19SurveyModel implements ISearchCovid19SurveyModel {
    pageIndex!: number;
    pageSize!: number;
    filters!: Filter[];
    sortBy!: Sort[];

    constructor(data?: ISearchCovid19SurveyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
            this.sortBy = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(Sort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCovid19SurveyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCovid19SurveyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISearchCovid19SurveyModel {
    pageIndex: number;
    pageSize: number;
    filters: Filter[];
    sortBy: Sort[];
}

export class VenueResponse implements IVenueResponse {
    id!: string;
    name!: string;
    isArchived!: boolean;

    constructor(data?: IVenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): VenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        return data; 
    }
}

export interface IVenueResponse {
    id: string;
    name: string;
    isArchived: boolean;
}

export class GetAllVenueResponse implements IGetAllVenueResponse {
    id!: string;
    name!: string;
    totalBuilding!: number;
    hasActiveBookings!: boolean;
    isArchived!: boolean;
    activeActions!: VenueAction[];

    constructor(data?: IGetAllVenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activeActions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalBuilding = _data["totalBuilding"];
            this.hasActiveBookings = _data["hasActiveBookings"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["activeActions"])) {
                this.activeActions = [] as any;
                for (let item of _data["activeActions"])
                    this.activeActions!.push(VenueAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllVenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllVenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalBuilding"] = this.totalBuilding;
        data["hasActiveBookings"] = this.hasActiveBookings;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.activeActions)) {
            data["activeActions"] = [];
            for (let item of this.activeActions)
                data["activeActions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAllVenueResponse {
    id: string;
    name: string;
    totalBuilding: number;
    hasActiveBookings: boolean;
    isArchived: boolean;
    activeActions: VenueAction[];
}

export class VenueAction implements IVenueAction {
    identifier!: number;
    name!: string;

    constructor(data?: IVenueAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VenueAction {
        data = typeof data === 'object' ? data : {};
        let result = new VenueAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        return data; 
    }
}

export interface IVenueAction {
    identifier: number;
    name: string;
}

export class CreateVenueResponse implements ICreateVenueResponse {
    id!: string;

    constructor(data?: ICreateVenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateVenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateVenueResponse {
    id: string;
}

export class CreateVenueModel implements ICreateVenueModel {
    name!: string;

    constructor(data?: ICreateVenueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateVenueModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVenueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateVenueModel {
    name: string;
}

export class UpdateVenueResponse implements IUpdateVenueResponse {
    id!: string;
    name!: string;

    constructor(data?: IUpdateVenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateVenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateVenueResponse {
    id: string;
    name: string;
}

export class UpdateVenueModel implements IUpdateVenueModel {
    name!: string;

    constructor(data?: IUpdateVenueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateVenueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVenueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateVenueModel {
    name: string;
}

export class SpaceWorkStationResponse implements ISpaceWorkStationResponse {
    id!: string;
    floorId!: string;
    waveId!: string;
    label!: string;
    workstationTypeId!: string;
    workPlaceTypeId!: string;
    hasLan!: boolean;
    isEnabled!: boolean;
    isPublished!: boolean;
    isElevatedTable!: boolean;
    isWheelChairAccess!: boolean;
    extraSocketStrips!: boolean;
    bookedUserId?: string | undefined;
    bookedUserName!: string;

    constructor(data?: ISpaceWorkStationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.floorId = _data["floorId"];
            this.waveId = _data["waveId"];
            this.label = _data["label"];
            this.workstationTypeId = _data["workstationTypeId"];
            this.workPlaceTypeId = _data["workPlaceTypeId"];
            this.hasLan = _data["hasLan"];
            this.isEnabled = _data["isEnabled"];
            this.isPublished = _data["isPublished"];
            this.isElevatedTable = _data["isElevatedTable"];
            this.isWheelChairAccess = _data["isWheelChairAccess"];
            this.extraSocketStrips = _data["extraSocketStrips"];
            this.bookedUserId = _data["bookedUserId"];
            this.bookedUserName = _data["bookedUserName"];
        }
    }

    static fromJS(data: any): SpaceWorkStationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceWorkStationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["floorId"] = this.floorId;
        data["waveId"] = this.waveId;
        data["label"] = this.label;
        data["workstationTypeId"] = this.workstationTypeId;
        data["workPlaceTypeId"] = this.workPlaceTypeId;
        data["hasLan"] = this.hasLan;
        data["isEnabled"] = this.isEnabled;
        data["isPublished"] = this.isPublished;
        data["isElevatedTable"] = this.isElevatedTable;
        data["isWheelChairAccess"] = this.isWheelChairAccess;
        data["extraSocketStrips"] = this.extraSocketStrips;
        data["bookedUserId"] = this.bookedUserId;
        data["bookedUserName"] = this.bookedUserName;
        return data; 
    }
}

export interface ISpaceWorkStationResponse {
    id: string;
    floorId: string;
    waveId: string;
    label: string;
    workstationTypeId: string;
    workPlaceTypeId: string;
    hasLan: boolean;
    isEnabled: boolean;
    isPublished: boolean;
    isElevatedTable: boolean;
    isWheelChairAccess: boolean;
    extraSocketStrips: boolean;
    bookedUserId?: string | undefined;
    bookedUserName: string;
}

export class SpaceMeetingRoomResponse implements ISpaceMeetingRoomResponse {
    id!: string;
    floorId!: string;
    waveId!: string;
    label!: string;
    hasLan!: boolean;
    isEnabled!: boolean;
    isPublished!: boolean;

    constructor(data?: ISpaceMeetingRoomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.floorId = _data["floorId"];
            this.waveId = _data["waveId"];
            this.label = _data["label"];
            this.hasLan = _data["hasLan"];
            this.isEnabled = _data["isEnabled"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): SpaceMeetingRoomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceMeetingRoomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["floorId"] = this.floorId;
        data["waveId"] = this.waveId;
        data["label"] = this.label;
        data["hasLan"] = this.hasLan;
        data["isEnabled"] = this.isEnabled;
        data["isPublished"] = this.isPublished;
        return data; 
    }
}

export interface ISpaceMeetingRoomResponse {
    id: string;
    floorId: string;
    waveId: string;
    label: string;
    hasLan: boolean;
    isEnabled: boolean;
    isPublished: boolean;
}

export class WorkPlaceTypeResponse implements IWorkPlaceTypeResponse {
    id!: string;
    name!: string;

    constructor(data?: IWorkPlaceTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkPlaceTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPlaceTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWorkPlaceTypeResponse {
    id: string;
    name: string;
}

export class WorkStationTypeResponse implements IWorkStationTypeResponse {
    id!: string;
    name!: string;

    constructor(data?: IWorkStationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkStationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWorkStationTypeResponse {
    id: string;
    name: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}